<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{route?.name}}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/expresotec/routes" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div [hidden]="!map" #map id="map"></div>

  <div class="fab-container2">
    <ion-fab-button color="warning" size="small" (click)="goStops()">
      <ion-icon src="/assets/icon/map-stops.svg"></ion-icon>
    </ion-fab-button>
    <ion-label>Paradas</ion-label>
  </div>
  <div
    class="fab-container-status"
    hidden
    *ngIf="buses && buses.length && !gettingSnappedRoute && !busLocationIntervalstarted"
  >
    <ion-fab-button color="secondary" size="small" (click)="startBusLocationInterval()">
      <ion-icon src="/assets/icon/status.svg"></ion-icon>
    </ion-fab-button>
    <ion-label>Status</ion-label>
  </div>

  <div class="fab-container" *ngIf="map">
    <ion-fab-button color="primary" size="small" (click)="updateLocation()">
      <ion-icon src="/assets/icon/map-location.svg"></ion-icon>
    </ion-fab-button>
    <ion-label>Ubicación</ion-label>
  </div>

  <div class="my-footer" *ngIf="route">
    <div class="my-card" *ngIf="!currentStop">
      <ion-row>
        <ion-col col-4 *ngIf="route.icon || route.image">
          <img [src]="route.icon || route.image" />
        </ion-col>
        <ion-col>
          <div class="v-center">
            <h2 color="custom">{{route.name }}</h2>
            <p>{{route.description}}</p>
            <p>Paradas: {{route.stops.length}}</p>
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div class="my-card currentStop" *ngIf="currentStop">
      <ion-row>
        <ion-col size="3" *ngIf="route.icon">
          <div class="v-center">
            <img [src]="route.icon" />
          </div>
        </ion-col>
        <ion-col>
          <div class="v-center">
            <h2 color="custom" *ngIf="currentStop.image && route.icon">{{currentStop.name | truncate : 35 }}</h2>
            <h2 color="custom" *ngIf="!currentStop.image || !route.icon">{{currentStop.name}}</h2>
            <div *ngIf="transportec && currentStop.timetable && currentStop.timetable.length">
              <p class="times">
                Horarios:
                <span *ngFor="let item of currentStop.timetable; let i = index">
                  <span *ngIf="i!==0">,</span>
                  {{item}}
                </span>
              </p>
            </div>
          </div>
        </ion-col>
        <ion-col size="4" *ngIf="currentStop.image">
          <div class="v-center">
            <img [src]="currentStop.image" class="photo" (click)="viewImage(currentStop.image, currentStop.name, '')" />
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
